export type GetUserInfoResponse = {
  id: number;
  email: string;
  name: string;
  nickname: string;
  profileImageUrl: string;
  role: string;
  createdAt: string;
  updatedAt: string;
};

export type CheckoutSessionResponse = {
  url: string;
};

export enum BookingStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum ServiceCategory {
  CHAT = "수다·티타임",
  GAME = "게임·듀오",
  TAROT = "타로·운세",
  FEEDBACK = "고민·피드백",
  STUDY = "랜선 스터디",
  FREE = "자유주제",
}

export enum CreatorTermsStatus {
  AGREED_TO_TERMS = "동의",
  DISAGREED_TO_TERMS = "비동의",
}

export enum CreatorApplicationStatus {
  PENDING_APPLICATION = "신청대기",
  ACCEPTED_APPLICATION = "신청수락",
  REJECTED_APPLICATION = "신청거절",
}

export enum WalletWithdrawStatus {
  PENDING = "대기",
  ACCEPTED = "승인",
  REJECTED = "거절",
}

export enum NotificationType {
  COMMON = "COMMON",
  ALERT = "ALERT",
  NOTICE = "NOTICE",
  EVENT = "EVENT",
  PAYMENT = "PAYMENT",
  SETTLEMENT = "SETTLEMENT",
}

export enum ERROR {
  SWEAR_WORD = "SWEAR_WORD",
  DUPLICATION = "DUPLICATION",
  AUTHENTICATION = "AUTHENTICATION",
  EID_AUTHENTICATION = "EID_AUTHENTICATION",
  EID_REFRESH_AUTHENTICATION = "EID_REFRESH_AUTHENTICATION",
  AUTHORIZATION = "AUTHORIZATION",
  NOT_EXIST_DATA = "NOT_EXIST_DATA",
  UNKNOWN_APP_ID = "UNKNOWN_APP_ID",
  WRONG_PASSWORD = "WRONG_PASSWORD",

  // User
  USER_DELETED = "USER_DELETED",
  USER_BLOCKED = "USER_BLOCKED",
  EXIST_PROFILE_ID = "EXIST_PROFILE_ID",

  //Wallet
  INVALID_WALLET_KLAV_AMOUNT = "INVALID_WALLET_KLAV_AMOUNT",
}
